module.exports = __webpack_public_path__ + "static/flags/AT-77d3ca4ea5508d8ddb6ff95d798bb5f6.gif";